import React from "react";
import CustomLayout from "./Common/Layouts/CustomLayout";
import UserDashboardLayout from "./Common/Layouts/UserDashboardLayout";
import Login from "./Pages/Login";
import Dashboard from "./Pages/Dashboard";
import ForgotPasswordScreen from "./Pages/ForgetPassword";
import Settings from "./Pages/Settings";
import CreateTicket from "./Pages/CreateTicket";
import { getToken } from "./apiSection/util";
import { Navigate } from "react-router-dom";
import CreateUserTabs from "./Pages/CreateUserTabs";
import SessionTimeout from "./Common/Components/SessionTimeout";
// import HindiToEnglishTranscriber from "./Pages/HindiToEnglishTranscriber";
import PrivacyPolicy from "./Pages/PrivacyPolicy"

export default function Routers(Redirectpath) {
  const TokenCheckRoute = ({ element }) => {
    const token = getToken();
    return token ? element : <Navigate to="/" />;
  };
  const LoginCheck = ({ element }) => {
    const token = getToken();
    return token ? <Navigate to="/dashboard" />:element;
  };
  let route = [
    {
      path: "/",
      element:( <LoginCheck
        element={<CustomLayout Redirectpath={Redirectpath} />}
      /> ),
      children: [
        { index: true, element: <Login Redirectpath={Redirectpath} /> },
        {
          path: "/Login",
          element: <Login Redirectpath={Redirectpath} />,
          children: [],
        },
        {
          path: "/privacy",
          element: <PrivacyPolicy Redirectpath={Redirectpath} />,
          children: [],
        },
        {
          path: "/sessionTimeout",
          element: <SessionTimeout Redirectpath={Redirectpath} />,
          children: [],
        },

        {
          path: "/ForgotPassword",

          element: <ForgotPasswordScreen Redirectpath={Redirectpath} />,
          children: [],
        },
      ],
    },
    {
      path: "/dashboard",
      element: (
        <TokenCheckRoute
          element={<UserDashboardLayout Redirectpath={Redirectpath} />}
        />
      ),
      children: [
        { index: true, element: <Dashboard Redirectpath={Redirectpath} /> },
        {
          path: "/dashboard/management",
          element: <Dashboard Redirectpath={Redirectpath} />,
          children: [],
        },
        {
          path: "/dashboard/createTicket",
          element: <CreateTicket Redirectpath={Redirectpath} />,
        },
        {
          path: "/dashboard/createUser",
          element: <CreateUserTabs Redirectpath={Redirectpath} />,
        },
      ],
    },
  ];

  return route;
}
